import PageTabContent from "@/App/Layouts/PageBody/PageTabContent";
import ViewContentBlock from "@/App/Layouts/ViewContentBlock";
import EntityCommentsChat from "@/common/components/Entity/Chat/View/EntityCommentsChat";
import { EntityType, RepairOperationDto } from "@/core/api/generated/v1";

interface Props {
  repairOperation: RepairOperationDto;
}

export default function CommentsTabContent({ repairOperation }: Props) {
  return (
    <PageTabContent>
      <ViewContentBlock spacing={2}>
        <EntityCommentsChat
          entityId={repairOperation.id!}
          entityType={EntityType.RepairOperation}
          entity={repairOperation}
        />
      </ViewContentBlock>
    </PageTabContent>
  );
}
